import React from 'react';
import { getContent } from './coreUtils';

export const BoldedLabel: React.FC<{
  inputValue: string;
  optionLabel: string;
  highlightJustBeginning: boolean;
  className: string;
}> = ({ inputValue, optionLabel, highlightJustBeginning, className }) => (
  <span className={className}>{getContent({ inputValue, optionLabel, highlightJustBeginning })}</span>
);
